<template>
  <div>
    <v-card
      flat
      tile
      :ripple="{ class: 'primary--text' }"
      class="d-flex justify-space-between align-center py-2 pl-4"
      @click="handleSwitch"
      @keydown.enter="handleSwitch"
    >
      <div class="d-flex align-center">
        <v-img
          src="/static/_v1/pd/icons/ui-kit/club/club-percent.svg"
          class="mr-4"
          width="24"
          height="24"
          alt="Иконка Процент Клуба"
        />
        <div class="d-flex flex-column align-start">
          <div class="text-body-1 text--text">
            Скидка на приём врача 30%
          </div>
          <div
            class="link-decoration-none primary--text"
            @click.stop="openDialog"
          >
            Подробнее
          </div>
        </div>
      </div>
      <v-switch
        :value="filtersStore.unsavedFilters.isClubAppointment"
        :input-value="filtersStore.unsavedFilters.isClubAppointment"
        color="primary"
        class="pt-0 mt-0 pl-1"
        hide-details
        dense
        inset
        @input="emitChanges"
      />
    </v-card>
    <ClubModal
      attach=".vue-the-lpu-filters .v-application"
      :value="isDialogOpened"
      @input="closeDialog"
    />
  </div>
</template>

<script setup lang="ts">
import useFiltersStore from 'www/vue_components/common/TheFilters/lpu/stores/useFiltersStore'
import useDialogManager from 'www/vue_components/common/mixins/DialogManager/useDialogManager'
import ClubModal from 'www/vue_components/common/TheFilters/common/components/ClubModal/ClubModal.vue'

const emit = defineEmits(['input'])

const filtersStore = useFiltersStore()
const { isDialogOpened, openDialog, closeDialog } = useDialogManager('SwitchClub')

const emitChanges = (isEnabled: boolean) => {
  filtersStore.updateUnsavedFilters({
    isClubAppointment: isEnabled || undefined,
  })
  emit('input', filtersStore.unsavedFilters)
}

const handleSwitch = () => {
  emitChanges(!filtersStore.unsavedFilters.isClubAppointment)
}
</script>
